// extracted by mini-css-extract-plugin
export default {"Triangle":"AlertTriangle_Triangle__Ed9nm"};